import { render } from "./SurveyQ72.vue?vue&type=template&id=613e0b3c&ts=true"
import script from "./SurveyQ72.vue?vue&type=script&lang=ts"
export * from "./SurveyQ72.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__